export default {"src":"/_next/static/media/passionfruit.af293a3d.svg","height":489,"width":489,"blurWidth":0,"blurHeight":0};